import { Box, Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  autocomplete: {
    width: 300,
  },
  autocompleteWide: {
    width: 400,
  },
}));

const EaDashboardFilters = ({ filters, onFilterChange, clients, files, isLoading }) => {
  const classes = useStyles();

  const handleClientChange = (event, newValue) => {
    onFilterChange({ clientId: newValue?.clientRecordId || null });
  };

  const handleFileChange = (event, newValue) => {
    onFilterChange({ fileId: newValue?.fileId || null });
  };

  const handleClearFilters = () => {
    onFilterChange({ clientId: null, fileId: null });
  };

  const selectedClient = clients.find((c) => c.clientRecordId === filters.clientId) || null;
  const selectedFile = files.find((f) => f.fileId === filters.fileId) || null;

  return (
    <Box className={classes.filtersContainer}>
      <Autocomplete
        className={classes.autocomplete}
        options={clients}
        getOptionLabel={(option) => option.shortName || option.legalName || ''}
        getOptionSelected={(option, value) => option.clientRecordId === value.clientRecordId}
        value={selectedClient}
        onChange={handleClientChange}
        disabled={isLoading}
        renderInput={(params) => (
          <TextField {...params} label="Client" variant="outlined" size="small" />
        )}
      />

      <Autocomplete
        className={classes.autocompleteWide}
        options={files}
        getOptionLabel={(option) =>
          option.authId && option.eeName
            ? `${option.authId} - ${option.eeName}`
            : option.authId || option.eeName || ''
        }
        getOptionSelected={(option, value) => option.fileId === value.fileId}
        value={selectedFile}
        onChange={handleFileChange}
        disabled={isLoading}
        renderInput={(params) => (
          <TextField {...params} label="Employee/File" variant="outlined" size="small" />
        )}
      />

      <Button onClick={handleClearFilters} disabled={isLoading}>
        Clear Filters
      </Button>
    </Box>
  );
};

EaDashboardFilters.propTypes = {
  filters: PropTypes.shape({
    clientId: PropTypes.number,
    fileId: PropTypes.number,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      clientRecordId: PropTypes.number,
      shortName: PropTypes.string,
      legalName: PropTypes.string,
    }),
  ),
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.number,
      authId: PropTypes.string,
      eeName: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
};

EaDashboardFilters.defaultProps = {
  clients: [],
  files: [],
  isLoading: false,
};

export default EaDashboardFilters;
